// assets
import { IconTypography, IconPalette, IconShadow, IconWindmill, IconBrandProducthunt } from '@tabler/icons';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

// constant
const icons = {
  IconTypography,
  IconPalette,
  IconShadow,
  IconWindmill,
  ViewStreamIcon,
  IconBrandProducthunt,
  ReceiptLongIcon
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const products = {
  id: 'products',
  title: 'Product Management',
  type: 'group',
  userRoles: ['Super Admin'],
  children: [
    {
      check:'view-products',
      id: 'products',
      title: 'Products',
      type: 'item',
      url: '/products',
      showCount: true,
      apiUrl:`${process.env.REACT_APP_APIPATH}/products/pending-product-count/`,
      icon: icons.IconBrandProducthunt,
      breadcrumbs: false
    },
    {
      check:'view-products',
      id: 'reportedProducts',
      title: 'Reported Products',
      type: 'item',
      url: '/reported-products',
      // showCount: true,
      // apiUrl:`${process.env.REACT_APP_APIPATH}/products/pending-product-count/`,
      icon: icons.IconBrandProducthunt,
      breadcrumbs: false
    },
    {
      check:'view-orders',
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      showCount: true,
      apiUrl:`${process.env.REACT_APP_APIPATH}/orders/pending-order-count/`,
      icon: icons.ReceiptLongIcon,
      breadcrumbs: false
    },
  ]
};

export default products;
